import API from "@/lib/API";

export const statusRevertService = {
  createRequest: async (data) => {
    return await API.post('/status-revert', data);
  },
  
  getPendingRequests: async () => {
    return await API.get('/status-revert');
  },
  
  reviewRequest: async (id, status) => {
    return await API.put(`/status-revert/${id}`, { status });
  }
};




